"use strict";

class Logger {
  constructor(classInstance) {
    this.logKey = classInstance.constructor.name;
  }

  log() {
    if(typeof window.JS_DEBUG_MODE === 'undefined' || window.JS_DEBUG_MODE < 1) return;
    console.log(this.logKey, ...arguments);
  }

  error() {
    if(typeof window.JS_DEBUG_MODE === 'undefined' || window.JS_DEBUG_MODE < 1) return;
    console.error(this.logKey, ...arguments);
  }

}
